export const buildRegisteredAgentData = ({
  agentData,
  answersMap,
  subscriptionDate = new Date().toISOString(),
}) => {
  const storeOwnerAnswer =
    answersMap.storeOwner || answersMap.store_owner || 'No'

  const referralSourceAnswer =
    answersMap.referralSource ||
    answersMap.referral_source ||
    'Social Media'

  const contactSourceAnswer =
    answersMap.contactSource ||
    answersMap.contact_source ||
    'Email'

  return {
    ...agentData,
    storeOwner: storeOwnerAnswer,
    referralSource: referralSourceAnswer,
    contactSource: contactSourceAnswer,
    subscriptionDate,
  }
}